export class AnalyticsGA4PagesModel {
    eventNameScreenView = 'screen_view';
    eventNameAlert = 'alert';
    eventNameClick = 'click';
    eventNameVisualization = 'visualization';
    titleError = 'algo-saiu-do-controle-mas-ja-estamos-resolvendo-para-voce';
    implementationTeam = '';
    customPathOverview = '';
    customPathAtualizacao = '';
    customPathConfiraSeusDados = '';
    customPathVinculoCorretora = '';
    customPathPessoasVinculadas = '';
    customPathTermos = '';
    customPathTelaSucesso = '';
    customPathConhecaProdutos = '';
    customPathNomeEscolhido = '';
    customPathEmail = '';
    customPathCelular = '';
    customPathTipoDocumento = '';
    customPathNomeCompleto = '';
    customPathNumeroDocumento = '';
    customPathOrgaoExpedidor = '';
    customPathEstadoExpeditor = '';
    customPathNomeMae = '';
    customPathDataNascimento = '';
    customPathPaisNascimento = '';
    customPathEstadoNascimento = '';
    customPathCidadeNascimento = '';
    customPathNascionalidade = '';
    customPathGenero = '';
    customPathEstadoCivil = '';
    customPathConjuge = '';
    customPathCep = '';
    customPathEnderecoCompleto = '';
    customPahExpostaPoliticamente = '';
    customPathOrigemRenda = '';
    customPathProfissao = '';
    customPathCnpj = '';
    customPathRenda = '';
    customPathPatrimonio = '';
    customPathPaisResidenciaFiscal = '';
    customPathPaisResidenciaFiscalBrasil = '';
    customPathNumeroNif = '';
    customPathDataNif = '';
    detailsStatus = '';
    customAceitarTermosUso? = '';
    customAceitarTermosUsoTermos? = '';
    customPathMenorDeIdade? = '';
    customPathCompletarDadosAppItau? = '';
    customPathOfertaServicos? = '';
}
